import router from './router'
import storage from 'store'
import NProgress from 'nprogress'
import '@/components/NProgress/nprogress.less'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { url } from './utils/redirectUrl'
import store from '@/store/'
import api from '@/api/'
import { asyncRouterMap } from '@/router/router.config'

NProgress.configure({ showSpinner: false })

const allowList = ['login', 'register', 'registerResult']
const loginRoutePath = '/user/login'
const defaultRoutePath = '/'
const whiteList = ['/user/login', '/404', '/403', '/']
let permissionRoutePath = '/'
router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const label = Object.keys(store.state.label.data)
  // 没有枚举请求
  if (!label.length) {
    await api.Label().then(res => {
      store.dispatch('set_label', res.data)
    })
}
  // 携带token
  if (to.query && to.query.token) {
    store.dispatch('getUserInfoByToken', to.query.token).then(() => {
      NProgress.done()
      next()
    }).catch(() => {
      storage.clearAll()
      NProgress.done()
      window.location.href = url
    })
  } else if (storage.get(ACCESS_TOKEN) && !to.query.code) {
    /* 是否有token */
    if (to.path === loginRoutePath) {
      next({ path: defaultRoutePath })
      NProgress.done()
    } else {
      try {
        // 遍历权限路由表 取路径
        const menu_permission = await store.dispatch('getMyMenus', storage.get(ACCESS_TOKEN))
        const myMenus = []
        const getShowPages = function(arr) {
          arr.forEach(item => {
            if (item.children && item.children.length > 0) {
              getShowPages(item.children)
            }
            if (!item.hidden) {
              myMenus.push(item.path)
            }
          })
        }
        getShowPages(menu_permission)
        // 跳转有权限的第一个路由 没有则403
        permissionRoutePath = myMenus[0] || '/403'
        if (myMenus.length > 0) {
          if (myMenus.includes(to.path) || to.meta.permission.length === 0 || whiteList.includes(to.path)) {
            next()
          } else if (permissionRoutePath && from.path === '/user/login') {
            next({ path: permissionRoutePath })
          } else {
            next({ path: '/403' })
          }
        } else {
         if (whiteList.includes(to.path)) {
          next()
         } else {
          next({ path: '/403' })
         }
        }
      } catch (error) {
        NProgress.done()
      }
    }
  } else {
    if (allowList.includes(to.name)) {
      // 在免登录名单，直接进入
      next()
    } else {
      if (to.query.token) {
        await store.commit('SET_TOKEN', to.query.token)
        api
          .tokenLogout()
          .then(res => {
            const { token = '', roles = [], permissions = {}, user = {} } = res.data
            store.commit('SET_TOKEN', token)
            // 设置角色
            store.commit('SET_ROLES', roles)
            // // 设置权限信息
            store.commit('SET_PERMISSION', permissions)
            // // 设置用户信息
            store.commit('SET_USER', user)
            next()
            NProgress.done()
          })
          .catch(() => {
            storage.clearAll()
            NProgress.done()
            window.location.href = url
          })
      } else {
        storage.clearAll()
        NProgress.done()
        window.location.href = url
      }
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
